import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  ListRelationshipTypesResponse,
  RelationshipTypeDefault,
  UpdateRelationshipTypeDefaultPayload,
} from '../models/relationship-type.model';

@Injectable({
  providedIn: 'root',
})
export class RelationshipTypeService {
  private readonly http = inject(HttpClient);

  getRelationshipTypes(): Observable<ListRelationshipTypesResponse> {
    return this.http.get<ListRelationshipTypesResponse>(`${environment.apiUrl}/relationship-types`);
  }

  downloadTemplate(type: string): Observable<Blob> {
    return this.http.get(
      `${environment.apiUrl}/relationship-types/${encodeURIComponent(type)}/template/download`,
      { responseType: 'blob' }
    );
  }

  updateDefault(
    id: number,
    data: UpdateRelationshipTypeDefaultPayload
  ): Observable<{ data: RelationshipTypeDefault }> {
    return this.http.patch<{ data: RelationshipTypeDefault }>(
      `${environment.apiUrl}/relationship-types/defaults/${id}`,
      data
    );
  }
}
